/* Pictures for Team introduction */
import Ollie from '../assets/about/Ollie.jpg'
import Alice from '../assets/about/Alice.jpg'

export const TEAM_DATA = [
    {
        id: 0,
        picture: Ollie,
        title: "Hi, I am Ollie.",
        description: (
            <>
                <p>I am a software engineer with a passion to solve real-world problems with the power of technology!</p>

                <p>I always am the planner when I travel with my friends. But notes and Excel spreadsheets are not convenient enough to keep up with our itineraries. Thus, TravelBuddy was born to help fellow travelers plan and manage their trips more easily!</p>
            </>
        )
    },
    {
        id: 2,
        picture: Alice,
        title: "Call me Alice.",
        description: (
            <>
                <p>I’m a digital marketer who tends to arrive first and plan second—drawn, more often than not, toward unfamiliar waters.</p>

                <p>But even non-planners need an anchor: something that allows freedom without drifting too far off course. TravelBuddy was built with that balance in mind.</p>

                <p>Our goal is to help travelers relax into the experience—calm, curious, and carefree, much like a capybara.</p>
            </>
        )
    }
]